import React, { Component } from 'react';
import styles from './EllipsisText.module.scss';

class EllipsisText extends Component {
  render() {
    const { children } = this.props;
    return <div className={styles['wrapper']}>{children}</div>;
  }
}

export default EllipsisText;
